module.exports = __webpack_public_path__ + "img/logo.48f2255d.png";